// src/components/Portfolio/DeficienciesObjects/GreenTeaExtract.js

const VitaminK1 = {
  productCode: "SBOVZ-K1",
  productName: "Vitamin K1 (Phylloquinone)",
  ingredients: "Green tea",
  overview:"Orgavitaz-K1-Phylloquinone is a standardized extract blend of Gyokuro type organic green tea and Parsley leaves sourced from self-sustained and biodynamic ecosystem, carefully dried to offer higher concentrations of Vitamin K1 along with its co-factors standardized for 1.5 % Phylloquinone. ",
  assay:"Natural Vitamin K1 1.5 %",
  coNutrients:"Co-nutrients from Gyokuro like flavonoids, polyphenols and proanthocyanidins are potent antioxidants. Polyphenols also block absorption of cholesterol in your intestines and increase its excretion. Besides, the menaquinones are present in traces not to the extent of claiming biological relevance. ",
  studies:"Comprehensive Stability studies, comparative studies with synthetic sources.",
  benefits:"Suitable as a natural anticoagulant and vascular health supplement, Supports as a good longevity vitamer ingredient in combination with Calcium and K2. Co-nutrients from Gyokuro like flavonoids, polyphenols and proanthocyanidins are potent antioxidants. Polyphenols also block absorption of cholesterol in your intestines and increase its excretion.",
  functionalUse: {
    main: "💊︎ Capsule, 🍚︎ Foods, 🥛︎ Beverages, 🚰︎ ORS, ⊘ Tablets (sensitive), 🍞︎ Baking,  🧂︎ Seasonings, 🍨︎ ice creams",
    note: "(Note:- heat and light sensitive, prone to oxidative stress)"
  },
  bannerImage: [
    "images/Portfolio/OrgavitazForDeficiencies/VitaminK1/VK1.png",
    "images/Portfolio/OrgavitazForDeficiencies/VitaminK1/VK2.png",
    "images/Portfolio/OrgavitazForDeficiencies/VitaminK1/VK3.png",
    "images/Portfolio/OrgavitazForDeficiencies/VitaminK1/VK4.png",
    "images/Portfolio/OrgavitazForDeficiencies/VitaminK1/VK5.png",



  ],
  certificates: [
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L1.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L2.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L3.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L4.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L6.png",
  ]
};

export default VitaminK1;
